export const ProgressBarXPProfile = ({ currentXp, total }) => {
  const percentage = Math.min((currentXp / total) * 100, 100);

  return (
    <div className="w-[121px] bg-[#fff] rounded-full h-[3px] flex items-center">
      <div
        className="bg-[#253FF6] h-[6px] rounded-full transition-all duration-300"
        style={{ width: `${percentage}%` }}
      />
    </div>
  );
};
